import Cookies from 'cookies';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { NextSeo } from 'next-seo';
import HomeContainer from '~/components/home/HomeContainer';
import { homeProject, homeTrack } from '~/constants/eventable';
import { PRECONNECT_LINKS } from '~/constants/preconnectLinks';
import HomeProviders, {
  type HomeProvidersProps
} from '~/context/home/HomeProviders';
import { type AppProps } from '~/pages/_app';
import setDatadogUser from '~/server-props/common/setDatadogUser';
import { isNotFound, isRedirect } from '~/server-props/common/utils/guards';
import getProps from '~/server-props/home/getProps';
import getRequestContext from '~/server-props/home/utils/getRequestContext';
import ErrorBoundary from '~/utilities/ErrorBoundary';

type OwnProps = {
  forProviders: HomeProvidersProps;
};

export default function HomePage(props: OwnProps) {
  return (
    <ErrorBoundary>
      <NextSeo
        title="Carvana | Buy & Finance Used Cars Online | At Home Delivery"
        additionalLinkTags={PRECONNECT_LINKS}
      />
      <HomeProviders
        eventableProject={homeProject}
        eventableTrack={homeTrack}
        {...props.forProviders}
      >
        <HomeContainer />
      </HomeProviders>
    </ErrorBoundary>
  );
}

export async function getServerSideProps(
  context: GetServerSidePropsContext
): Promise<
  GetServerSidePropsResult<
    AppProps & {
      forProviders: HomeProvidersProps;
    }
  >
> {
  const requestContext = await getRequestContext(context.req);
  const serverCookies = new Cookies(context.req, context.res, { secure: true });

  const result = await getProps(context, requestContext, serverCookies);

  if (isNotFound(result) || isRedirect(result)) {
    return result;
  }

  const { forApp, forProviders } = await result.props;

  setDatadogUser(context, serverCookies);

  return { props: { ...forApp, forProviders } };
}
